import {Component, OnInit} from '@angular/core';
import {SpecialistViewInterface} from '@interfaces/specialist.interface';
import {ActivatedRoute, Router} from '@angular/router';
import {FormControl, FormGroup} from '@angular/forms';
import {AuthService} from '@services/auth.service';
import {UserNamespace} from '@namespaces/user.namespace';

@Component({
    selector: 'app-specialist-view',
    templateUrl: './specialist-view.component.html',
})
export class SpecialistViewComponent implements OnInit {
    public specialist: SpecialistViewInterface;

    public editUrl = '../../edit';

    public form = new FormGroup({
        status: new FormControl(1) // По-умолчанию "Работает"
    });

    public allowStatusChange = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authSerive: AuthService,
    ) {}

    ngOnInit() {
        /**
         * Специалиста получаем через resolver
         */
        this.specialist = this.route.snapshot.data.specialist;

        if (this.specialist) {
            this.form.get('status').patchValue(this.specialist.status);
        }

        this.allowStatusChange = this.authSerive.hasPermissions([UserNamespace.Permission.specialistSetStatus]);
    }

    openEdit(fragment: string = null) {
        this.router.navigate([this.editUrl, this.specialist.id], {relativeTo: this.route, fragment: fragment});
    }
}
